import {
  useStoreId,
  useUID,
} from "@coworker/app/src/core/auth/useLoggedInUser";
import { useCallback } from "react";
import { TaskType } from "@coworker/apprestructured/src/task-management/types/TaskType";
import {
  isLoading,
  Loading,
} from "@coworker/apprestructured/src/task-management/loading";
import {
  isRecord,
  merge,
} from "@coworker/apprestructured/src/shared/helpers/object.helper";

const EMPTY_INITIAL_TASK = {};

function useCreateInitialTask() {
  const myUserId = useUID();
  const myStoreId = useStoreId();

  return useCallback(
    (
      taskType: TaskType | Loading,
      initialValues: Record<string, unknown> | null
    ) => {
      if (isLoading(taskType)) {
        return EMPTY_INITIAL_TASK;
      }
      const details = taskType.details.reduce(
        (res, curr) => {
          res[curr.name] = curr.initial;
          return res;
        },
        {} as Record<string, unknown>
      );

      const task: Record<string, unknown> = {
        priority: false,
        assigned_user_id: null,
        assigned_team_id: null,
        state: "pending",
        close_reason_id: null,
        close_description: "",
        image_ids: [],
        file_ids: [],
        links: [],
        start: null,
        creator_user_id: myUserId,
        store_id: myStoreId,
        details,
        task_type_id: taskType.id,
      };

      if (!isRecord(initialValues) || Object.keys(initialValues).length === 0) {
        return task;
      }

      return merge(task, initialValues);
    },
    [myStoreId, myUserId]
  );
}

export default useCreateInitialTask;
